import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * タイトル付きパネル
 */
export default function TitledPanel({
  sx,
  title,
  headers,
  children,
}) {

  // 開閉状態
  const [ expanded, setExpanded ] = React.useState(true);

  // 開閉ボタン押下
  const handleExpand = React.useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  //
  // 描画
  //
  return (
    <Paper sx={{ px: 2, py: 0, ...sx }}>

      {/* ヘッダー */}
      <Stack direction="row"
        alignItems="center"
        sx={{ py: 1 }}
      >
        {/* タイトル */}
        {title && <Typography variant="subtitle1">{title}</Typography>}

        {/* ヘッダー追加要素 */}
        {headers}

        {/* 左右分割スペーサー */}
        <Box sx={{ flexGrow: 1 }} />

        {/* 開閉ボタン(右寄せ) */}
        <IconButton
          onClick={handleExpand}
          sx={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: '0.3s',
          }}
        >
          {/* 開閉アイコン */}
          <ExpandMoreIcon />
        </IconButton>
      </Stack>

      {/* ボディ開閉 */}
      <Collapse in={expanded} timeout="auto" unmountOnExit={false}
        sx={{
          // ボディ下余白
          '& .MuiCollapse-wrapper': { marginBottom: 2 },
        }}
      >
        {/* ボディ本体 */}
        {children}
      </Collapse>
    </Paper>
  );
}
